import Timeline from './Timeline';
import TimelineItem from './TimelineItem';

Timeline.Item = TimelineItem;
export default Timeline;
